/**
 * 通用js方法封装处理
 *
 */

export const handleChunk = (arr, size) => {
  var num = [];
  for (var i = 0; i < Math.ceil(arr.length / size); i++) {
    var start = i * size;
    var end = start + size;
    num.push(arr.slice(start, end));

  }
  return num;

}

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
  let search = params;
  search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
  dateRange = Array.isArray(dateRange) ? dateRange : [];
  if (typeof (propName) === 'undefined') {
    search.params['beginTime'] = dateRange[0];
    search.params['endTime'] = dateRange[1];
  } else {
    search.params['begin' + propName] = dateRange[0];
    search.params['end' + propName] = dateRange[1];
  }
  return search;
}


/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}

// 验证是否为blob格式
export async function blobValidate(data) {
  try {
    const text = await data.text();
    JSON.parse(text);
    return false;
  } catch (error) {
    return true;
  }
}

const formatNumber = (n) => {
  n = n.toString();
  return n[1] ? n : '0' + n;
}

export const dataFormat = (number, format='Y-M-D') => {
  const formatArr = ['Y', 'M', 'D', 'h', 'm', 's'];
  const returnArr = [];
  const date = new Date(number);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));

  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));

  for (let i in returnArr) {
    format = format.replace(formatArr[i], returnArr[i]);
  }
  return format;
}


/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}


/**
 * 根据数组中元素的属性名排序
 * @param {数组} arrays 
 * @param {数组元素的属性名} key 
 * @returns 排序后的数组，小的在前
 */
export function sortArrayByKey(arrays, key){
  let newArrays = arrays.slice(0)
  newArrays.sort(function(a, b) {
      if (typeof a[key] === "string") {
          let x = a[key].toLowerCase()
          let y = b[key].toLowerCase()
          return x < y ? -1 : x > y ? 1 : 0
      }else if(typeof a[key] === "number")
          return a[key] - b[key]
      else return a[key] - b[key]    
  })
  return newArrays
}

// 下划线转骆峰
export function underscoreToCamel(str) {
  return str.replace(/_\w/g, function (match) {
      return match[1].toUpperCase();
  });
}

export function findNodeByCode(treeData, code) {
  for(var i = 0;i < treeData.length; i++) {
    var node = treeData[i]
    if (node.path === code) {
      return node
    }

    if(node.children && node.children.length > 0) {
      var foundNode = findNodeByCode(node.children, code)
      if (foundNode ) {
        return foundNode
      }
    }
  }
  return null
}


// WEBPACK FOOTER //
// ./src/utils/index.js